import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import api from "@/lib/axios"
import SkeletonTable from "@/components/SkeletonTable"

const getListJurusanSekolah = async () => {
  const response = await api.get("/master/jurusan-sekolah/index", {
    withCredentials: true,
  })
  return response.data?.data
}

export default function MasterJurusanSekolahPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listJurusanSekolah"],
    queryFn: getListJurusanSekolah,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
